import { useTheme } from '@mui/material';
const useLiveFeedStyles = () => {
    const theme = useTheme();
    const HeaderHeight = '48px';
    const BottomNavigationHeight = '56px';
    return {
        LiveFeedMainContainer: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            height: `calc(100dvh - ${HeaderHeight} - ${BottomNavigationHeight})`,
            overflowY: 'auto',
            position: 'relative',
            alignItems: 'center',
        },
        MediasContainer: {
            pt: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            overflowY: 'auto',
        },
        NoteContainer: {
            pt: 3,
            p: 2
        },
    };
};
export default useLiveFeedStyles;
